/* eslint-disable */
import * as Types from '../../../../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetCorrectionVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetCorrectionDTO = (
  { __typename?: 'Query' }
  & { correction: (
    { __typename?: 'Correction' }
    & Pick<Types.CorrectionDTO, 'id' | 'originalText' | 'replacement'>
  ) }
);


export const GetCorrectionDocumentDTO = gql`
    query getCorrection($id: String!) {
  correction(id: $id) {
    id
    originalText
    replacement
  }
}
    `;

/**
 * __useGetCorrection__
 *
 * To run a query within a React component, call `useGetCorrection` and pass it any options that fit your needs.
 * When your component renders, `useGetCorrection` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorrection({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCorrection(baseOptions: Apollo.QueryHookOptions<GetCorrectionDTO, GetCorrectionVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorrectionDTO, GetCorrectionVariablesDTO>(GetCorrectionDocumentDTO, options);
      }
export function useGetCorrectionLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetCorrectionDTO, GetCorrectionVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorrectionDTO, GetCorrectionVariablesDTO>(GetCorrectionDocumentDTO, options);
        }
export type GetCorrectionHookResult = ReturnType<typeof useGetCorrection>;
export type GetCorrectionLazyQueryDTOHookResult = ReturnType<typeof useGetCorrectionLazyQueryDTO>;
export type GetCorrectionQueryResultDTO = Apollo.QueryResult<GetCorrectionDTO, GetCorrectionVariablesDTO>;